module.exports = __webpack_public_path__ + "assets/img/dd87d6b9ec26c8551aefdb69b191c495.svg";